import { useContext, useEffect } from 'react'
import { FieldValues, UseFormSetValue } from 'libs/form'
import { StoreSettingsContext } from 'store'
import { Country } from 'shared/types/general.types'

type UseSetCountryProps = {
	countries: Country[] | undefined
	setValue: UseFormSetValue<FieldValues>
}

export const useSetCountry = ({ countries, setValue }: UseSetCountryProps) => {
	const storeCtx = useContext(StoreSettingsContext)

	useEffect(() => {
		if (
			countries?.length &&
			(storeCtx?.storeSettings?.address?.country || storeCtx?.storeSettings?.legal_address?.country)
		) {
			setValue('country', {
				value: storeCtx?.storeSettings?.address?.country,
				label: countries?.find(
					(country) => country.value === storeCtx?.storeSettings?.address?.country
				)?.display_name
			})
			setValue('legal_country', {
				value: storeCtx?.storeSettings?.legal_address?.country,
				label: countries.find(
					(country: any) => country.value === storeCtx?.storeSettings?.legal_address?.country
				)?.display_name
			})
		}
	}, [
		countries,
		storeCtx?.storeSettings?.address?.country,
		storeCtx?.storeSettings?.legal_address?.country
	])
}
